// src/components/Calendar/CalendarHeader.jsx
import React from 'react';
import {
    Box,
    Typography,
    Button,
    ButtonGroup,
    Select,
    MenuItem,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TodayIcon from '@mui/icons-material/Today';
import AddIcon from '@mui/icons-material/Add';

export default function CalendarHeader({
    calendarRef,
    title,
    onAddClick,
    filter,
    setFilter,
}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                mb: 1,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',    // 한 줄 넘치면 줄바꿈
                gap: 1,
            }}
        >
            {/* 타이틀 (모바일 생략) */}
            <Box sx={{ flex: 1, textAlign: 'center' }}>
                {!isMobile && (
                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 'bold', fontSize: { sm: '2rem', md: '2.5rem' } }}
                    >
                        {title}
                    </Typography>
                )}
            </Box>

            {/* ← / →  +  오늘/일정추가 버튼 */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ButtonGroup size="small" variant="outlined">
                    <Button onClick={() => calendarRef.current?.getApi().prev()}>
                        <ChevronLeftIcon fontSize="small" />
                    </Button>
                    <Button onClick={() => calendarRef.current?.getApi().next()}>
                        <ChevronRightIcon fontSize="small" />
                    </Button>
                </ButtonGroup>

                {isMobile ? (
                    <Button
                        onClick={onAddClick}
                        variant="contained"
                        startIcon={<AddIcon />}
                        sx={{ px: 2, py: 1, fontSize: '0.9rem', fontWeight: 'bold' }}
                    >
                        일정 추가
                    </Button>
                ) : (
                    <Button
                        onClick={() => calendarRef.current?.getApi().today()}
                        variant="contained"
                        startIcon={<TodayIcon />}
                        sx={{ px: 2, py: 1, fontSize: '0.95rem', fontWeight: 'bold' }}
                    >
                        오늘
                    </Button>
                )}
            </Box>

            {/* 필터: 데스크톱은 오른쪽에, 모바일은 다음 줄 full-width */}
            {!isMobile ? (
                <Select
                    size="small"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    sx={{ minWidth: 120 }}
                >
                    <MenuItem value="all">전체</MenuItem>
                    <MenuItem value="schedule">일정</MenuItem>
                    <MenuItem value="content">컨텐츠</MenuItem>
                </Select>
            ) : (
                <Box sx={{ flexBasis: '100%', mt: 1 }}>
                    <Select
                        fullWidth
                        size="small"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    >
                        <MenuItem value="all">전체</MenuItem>
                        <MenuItem value="schedule">일정</MenuItem>
                        <MenuItem value="content">컨텐츠</MenuItem>
                    </Select>
                </Box>
            )}
        </Box>
    );
}
